import * as Models from "../Models";
import * as Common from "../Common/modules";

    export interface IAuthApiClient {
        postLogin: (loginRequest: Models.Auth.LoginRequest.LoginRequest) => ng.IPromise<Models.Auth.LoginResponse.LoginResponse>;
        postResetPassword: (resetPasswordRequest: Models.Auth.ResetPasswordRequest.ResetPasswordRequest) => ng.IPromise<Models.Auth.ResetPasswordResponse.ResetPasswordResponse>;
        postCheckPasswordResetCode: (checkPasswordResetCodeRequest: Models.Auth.CheckPasswordResetCodeRequest.CheckPasswordResetCodeRequest) => ng.IPromise<Models.Auth.CheckPasswordResetCodeResponse.CheckPasswordResetCodeResponse>;
        postForgotPassword: (forgotPasswordRequest: Models.Auth.ForgotPasswordRequest.ForgotPasswordRequest) => ng.IPromise<Models.Auth.ForgotPasswordResponse.ForgotPasswordResponse>;
        getLogout: () => ng.IPromise<Models.Auth.LogoutResponse.LogoutResponse>;
        getUser: () => ng.IPromise<Models.Auth.GetUserResponse.GetUserResponse>;
        postChangePasswordRequest: (changePasswordRequest: Models.Auth.ChangeCurrentUserPasswordRequest.ChangeCurrentUserPasswordRequest) => ng.IPromise<Models.Auth.ChangeCurrentUserPasswordResponse.ChangeCurrentUserPasswordResponse>;
        getUserEmailsInPartner: () => ng.IPromise<string[]>;
        getUserEmailsByPartner: (partner: Models.PartnerModel.IPartnerModel) => ng.IPromise<string[]>;
    }

    export class AuthApiClient implements IAuthApiClient {
        
        private prefix: string;

        public static $inject = ['igs.apiClientService'];
        constructor(private apiClient: Common.ApiClientService.Igs.Common.IApiClientService) {
            this.prefix = "authentication";
        }

        public postLogin = (loginRequest: Models.Auth.LoginRequest.LoginRequest): ng.IPromise<Models.Auth.LoginResponse.LoginResponse> => {
            return this.apiClient.post<Models.Auth.LoginResponse.LoginResponse>(this.prefix + '/login', loginRequest);
        }

        public postResetPassword = (resetPasswordRequest:  Models.Auth.ResetPasswordRequest.ResetPasswordRequest): ng.IPromise<Models.Auth.ResetPasswordResponse.ResetPasswordResponse> => {
            return this.apiClient.post<Models.Auth.ResetPasswordResponse.ResetPasswordResponse>(this.prefix + '/resetpassword', resetPasswordRequest);
        }

        public postCheckPasswordResetCode = (checkPasswordResetCodeRequest: Models.Auth.CheckPasswordResetCodeRequest.CheckPasswordResetCodeRequest): ng.IPromise<Models.Auth.CheckPasswordResetCodeResponse.CheckPasswordResetCodeResponse> => {
            return this.apiClient.post<Models.Auth.CheckPasswordResetCodeResponse.CheckPasswordResetCodeResponse>(this.prefix + '/checkresetcode', checkPasswordResetCodeRequest);
        }

        public postForgotPassword = (forgotPasswordRequest: Models.Auth.ForgotPasswordRequest.ForgotPasswordRequest): ng.IPromise<Models.Auth.ForgotPasswordResponse.ForgotPasswordResponse> => {
            return this.apiClient.post<Models.Auth.ForgotPasswordResponse.ForgotPasswordResponse>(this.prefix + '/forgotpassword', forgotPasswordRequest);
        }

        public getLogout = (): ng.IPromise<Models.Auth.LogoutResponse.LogoutResponse> => {
            return this.apiClient.get<Models.Auth.LogoutResponse.LogoutResponse>(this.prefix + '/logout');
        }

        public getUser = (): ng.IPromise<Models.Auth.GetUserResponse.GetUserResponse> => {
            return this.apiClient.get<Models.Auth.GetUserResponse.GetUserResponse>(this.prefix + '/user');
        }

        public postChangePasswordRequest = (changePasswordRequest: Models.Auth.ChangeCurrentUserPasswordRequest.ChangeCurrentUserPasswordRequest): ng.IPromise<Models.Auth.ChangeCurrentUserPasswordResponse.ChangeCurrentUserPasswordResponse> => {
            return this.apiClient.post(this.prefix + '/changepassword', changePasswordRequest);
        }

        public getUserEmailsInPartner = (): ng.IPromise<string[]> => {
            return this.apiClient.post(this.prefix + '/GetUserEmailsInPartner');
        }

        public getUserEmailsByPartner = (partner: Models.PartnerModel.IPartnerModel): ng.IPromise<string[]> => {
            return this.apiClient.post(this.prefix + '/GetUserEmailsByPartner', partner);
        }
    }
